import React from 'react';
import PropTypes from 'prop-types';
import { CircleNotch } from '@phosphor-icons/react';
import './style.scss';

const ButtonLoader = ({ 
  size = 20, 
  color = '#FF2459', 
  className = '',
  text = 'Loading...',
  showText = false
}) => {
  return (
    <div className={`button-loader flex items-center justify-center gap-2 ${className}`}>
      <CircleNotch
        className="loader-icon animate-spin"
        size={size}
        color={color}
      />
    </div>
  );
};

ButtonLoader.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  showText: PropTypes.bool,
};

export default ButtonLoader;
